import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CoreService} from '../../../../../../../shared/src/lib/services/core.service';
import {MatDialog} from '@angular/material/dialog';
import {navItems} from '../../vertical/sidebar/sidebar-data';
import {TranslateService} from '@ngx-translate/core';
import {Router, RouterModule} from '@angular/router';
import {TablerIconsModule} from 'angular-tabler-icons';
import {BrandingComponent} from '../../vertical/sidebar/branding.component';
import {FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FeatherModule} from 'angular-feather';
import {MaterialModule} from '../../../../material.module';
import {ApiService} from '../../../../../../../shared/src/lib/services/api.service';
import {NgScrollbarModule} from "ngx-scrollbar";
import {DecimalPipe, NgIf} from "@angular/common";
import {EventService} from "../../../../../../../shared/src/lib/services/event.service";

interface notifications {
  id: number;
  img: string;
  title: string;
  subtitle: string;
}

interface profiledd {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

interface apps {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

interface quicklinks {
  id: number;
  title: string;
  link: string;
}

@Component({
  selector: 'app-horizontal-header',
  standalone: true,
  imports: [
    RouterModule,
    TablerIconsModule,
    MaterialModule,
    BrandingComponent,
    FeatherModule,
    NgScrollbarModule,
    ReactiveFormsModule,
    NgIf,
    DecimalPipe,
  ],
  templateUrl: './header.component.html',
})
export class AppHorizontalHeaderComponent implements OnInit{
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  showFiller = false;
  userData = {NAME: '', BALANCE: 0, ROLE_NAME: ''};
  searchParam = new FormControl('');
  uData: any;

  public selectedLanguage: any = {
    language: 'English',
    code: 'en',
    type: 'US',
    icon: '/assets/images/flag/icon-flag-en.svg',
  };

  public languages: any[] = [
    {
      language: 'English',
      code: 'en',
      type: 'US',
      icon: '/assets/images/flag/icon-flag-en.svg',
    },
    {
      language: 'Español',
      code: 'es',
      icon: '/assets/images/flag/icon-flag-es.svg',
    },
    {
      language: 'Français',
      code: 'fr',
      icon: '/assets/images/flag/icon-flag-fr.svg',
    },
    {
      language: 'German',
      code: 'de',
      icon: '/assets/images/flag/icon-flag-de.svg',
    },
  ];

  constructor(
    private vsidenav: CoreService,
    public dialog: MatDialog,
    private translate: TranslateService,
    private apiService: ApiService,
    private router: Router,
    private eventService: EventService,
  ) {
    translate.setDefaultLang('en');

    this.searchParam.valueChanges.subscribe(value => {
      if (!value) {
        this.eventService.searchEvent.emit(value);
      }

    })

    this.eventService.updateEvent.subscribe(value => {
      if (value) {
        this.getUserDetails(this.uData.ID);
      }
    })
  }

  ngOnInit(): void {
    let uData = this.apiService.getUserData();
    this.uData = uData;
    this.getUserDetails(uData.ID);
  }

  activateSearch() {

    this.eventService.searchEvent.emit(this.searchParam.value);
  }

  openDialog() {
    const dialogRef = this.dialog.open(AppHorizontalSearchDialogComponent);

    dialogRef.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
    });
  }

  changeLanguage(lang: any): void {
    this.translate.use(lang.code);
    this.selectedLanguage = lang;
  }

  getUserData() {
    return this.apiService.getUserData();
  }

 getUserDetails(id:string) {
    let resp = this.apiService.send2ServerRelative(
      `users/get/${id}`
    );
    resp.subscribe((data) => {
      if (data.status == 'ok') {
        this.userData = data.result[0];
      }
    })
  }

  logOut() {
    this.apiService.clearUserToken();
    this.router.navigate(['/authentication/login'])
  }

  get isSearchPage() {
   return this.router.url === '/home/users';
  }
  notifications: notifications[] = [
    {
      id: 1,
      img: '/assets/images/profile/user-1.jpg',
      title: 'Roman Joined the Team!',
      subtitle: 'Congratulate him',
    },
    {
      id: 2,
      img: '/assets/images/profile/user-2.jpg',
      title: 'New message received',
      subtitle: 'Salma sent you new message',
    },
    {
      id: 3,
      img: '/assets/images/profile/user-3.jpg',
      title: 'New Payment received',
      subtitle: 'Check your earnings',
    },
    {
      id: 4,
      img: '/assets/images/profile/user-4.jpg',
      title: 'Jolly completed tasks',
      subtitle: 'Assign her new tasks',
    },
    {
      id: 5,
      img: '/assets/images/profile/user-5.jpg',
      title: 'Roman Joined the Team!',
      subtitle: 'Congratulate him',
    },
  ];

  profiledd: profiledd[] = [
    {
      id: 1,
      img: '/assets/images/svgs/icon-account.svg',
      title: 'My Profile',
      subtitle: 'Account Settings',
      link: '/',
    },
  ];
}

@Component({
  selector: 'app-search-dialog',
  standalone: true,
  imports: [RouterModule, MaterialModule, TablerIconsModule, FormsModule],
  templateUrl: 'search-dialog.component.html',
})
export class AppHorizontalSearchDialogComponent {
  searchText: string = '';
  navItems = navItems;

  navItemsData = navItems.filter((navitem) => navitem.displayName);

  // filtered = this.navItemsData.find((obj) => {
  //   return obj.displayName == this.searchinput;
  // });

}
